import { createContext } from 'react';

interface PermitMeasurementContext {
  showInMetric: boolean;
  setShowInMetric: (newValue: boolean) => void;
}

export const PermitMeasurementContext = createContext<PermitMeasurementContext>(
  {
    showInMetric: false,
    setShowInMetric: () => undefined,
  },
);
